module.exports = __webpack_public_path__ + "d1cc08eac3e6e1bd02914a5e65aa707d.svg";